import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { DisplayComponents, DisplayService } from './app.component.service';
import { TranslateConfigService } from './services/translate-config.service';
import { SpinnerService } from './shared/spinner/spinner.service';
import { Utilitarios } from './shared/utilitarios';
import { PreCheckoutQuery } from './state/pre-checkout.query';
import { AlertService, ErrorMessage, ErrorService } from './services/alert.service';
import { NavigationEnd, Router } from '@angular/router';
import { StateService } from './state/state.service';
import { ModalConfig } from './models/modal.config';
import { ModalComponent } from './shared/modal/modal.component';
import { DisplayLoginComponents, PreCheckoutLoginService } from './pages/pre-checkout-login/pre-checkout-login.service';
import { PreCheckoutVeiculoService, ValuesVeiculo } from './pages/pre-checkout-veiculo/pre-checkout-veiculo.service';
import { PreCheckoutViagemService, Values } from './pages/pre-checkout-viagem/pre-checkout-viagem.service';
import { PreCheckoutService } from './services/pre-checkout.service';
import { Auth } from './models/auth.model';
import { PreCheckoutChecklistComponent } from './pages/pre-checkout-checklist/pre-checkout-checklist.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  // Async observable variables
  cpf$: Observable<string>;
  name$: Observable<string>;
  phone$: Observable<string>;
  route$: Observable<string>;
  sm$: Observable<string>;
  originCd$: Observable<string>;
  destinoCd$: Observable<string>;
  transporter$: Observable<string>;
  transporterType$: Observable<string>;
  hash$: Observable<string>;
  plates$: Observable<Array<any>>;
  stageLogin$: Observable<boolean>;
  stageViagem$: Observable<boolean>;
  stageVeiculo$: Observable<boolean>;

  translation: any;
  error: ErrorMessage = new ErrorMessage();
  displayComponents: DisplayComponents = new DisplayComponents();
  timeLeft: number;
  interval;
  clock: string = null;

  modalConfig: ModalConfig = { 
    modalTitle: ""
  };

  modalConfigChecklist: ModalConfig = { 
    modalTitle: ""
  };

  @ViewChild('modalExit') private modalExitComponent: ModalComponent
  @ViewChild('modalChecklist') private modalChecklistComponent: ModalComponent
  cpfSessao: string = ''
  @ViewChild('selectorChecklist') private selectorChecklistComponent: PreCheckoutChecklistComponent

  constructor(
    private preCheckoutQuery: PreCheckoutQuery,
    private translateConfigService: TranslateConfigService,
    private errorService: ErrorService,
    private spinnerService: SpinnerService,
    private displayService: DisplayService,
    private preCheckoutService: PreCheckoutService,
    private alertService: AlertService,
    private router: Router){
      this.errorService.getShowAlert().subscribe((result)=>{
          this.error = result

          if(result.tentativa==3)
            this.tentativas();
      });

      this.displayService.getDisplay().subscribe((result)=>{
        this.displayComponents = result
      });

      this.router.events.subscribe(
        (event: any) => {
          if (event instanceof NavigationEnd) {
            //Caso a rota não seja informada, faz redirect para a página inicial
            if(this.router.url=="/") this.router.navigate(['/start']);
            
            //Oculta o botão de sair da página inicial
            (this.router.url=="/start") ? this.displayComponents.buttonExit=false : this.displayComponents.buttonExit=true;
          }
        }
      );
  }

  setVariables(){
    this.cpf$ = this.preCheckoutQuery.cpf$;
    this.name$ = this.preCheckoutQuery.name$;
    this.phone$ = this.preCheckoutQuery.phone$;
    this.route$ = this.preCheckoutQuery.route$;
    this.sm$ = this.preCheckoutQuery.sm$;
    this.originCd$ = this.preCheckoutQuery.originCd$;
    this.destinoCd$ = this.preCheckoutQuery.destinoCd$;
    this.transporter$ = this.preCheckoutQuery.transporter$;
    this.transporterType$ = this.preCheckoutQuery.transporterType$;
    this.hash$ = this.preCheckoutQuery.hash$;
    this.plates$ = this.preCheckoutQuery.plates$;
    this.stageLogin$ = this.preCheckoutQuery.stageLogin$;
    this.stageViagem$ = this.preCheckoutQuery.stageViagem$;
    this.stageVeiculo$ = this.preCheckoutQuery.stageVeiculo$;
    this.timeLeft = Utilitarios.WAIT_TIME;
  }

  watch(){
    setInterval(function() {
      this.clock = `${Utilitarios.getDate()} ${Utilitarios.getTime()}`;
    }.bind(this), 1000);
  }

  ngOnInit() {
    this.getAccessToken();
    this.setVariables();
    this.watch();

    this.atualizaCpfChecklist();
  }

  closeAlert() {
    this.error = new ErrorMessage();
  }

  tentativas()
  {
    this.lockScreem();
    this.startTimer();
    setTimeout(function(){ 
      this.unlockScreem();
    }.bind(this), 
    this.timeLeft);
  }
  
  lockScreem()
  {
    this.spinnerService.requestStarted("ampulheta.gif", null);
  }

  unlockScreem()
  {
    this.spinnerService.resetSpinner();
  }

  startTimer() {
    
    this.interval = setInterval(() => {
      if(this.timeLeft > 0){
        this.timeLeft = this.timeLeft-1000;
      }
      else{
        clearInterval(this.interval);
        this.timeLeft = Utilitarios.WAIT_TIME;
        this.error.tentativa = 0;
      }
    },1000)
  }

  millisecondsToTime(milliseconds) {
    return Utilitarios.millisecondsToTime(milliseconds);
  }

  exit(){
    setTimeout(function(){ this.openModalCadastroViagem(); }.bind(this), 100);
  }

  consultaChecklist(){
    setTimeout(function(){ this.openModalChecklist(); }.bind(this), 100);
  }

  openModalCadastroViagem() {
    this.modalConfig.modalTitle = "Aviso";
    this.modalConfig.closeButtonLabel = "Sim";
    this.modalConfig.dismissButtonLabel = "Não";
    this.modalConfig.shouldClose = this.onSalvar.bind(this);
    this.modalConfig.onDismiss = this.onCancelar.bind(this);

    return this.modalExitComponent.open();
  }

  openModalChecklist() {
    this.modalConfigChecklist.modalTitle = "Consultar Checklist";
    this.modalConfigChecklist.dismissButtonLabel = "Fechar";
    this.modalConfigChecklist.onDismiss = this.onCancelarChecklist.bind(this);
    this.modalConfigChecklist.hideCloseButton = function() {return true;}
    this.selectorChecklistComponent.checklistForm.patchValue({
      placa: '',
      cpf: this.cpfSessao
    });

    return this.modalChecklistComponent.open();
  }
  
  onSalvar() {
    window.location.href = "/start";
    return true;
  }

  onCancelar(){
    
  }

  onCancelarChecklist() {
    this.selectorChecklistComponent.limpar();
  }

  formataCPF(cpf: string): string{
    return Utilitarios.formataCPF(cpf)
  }

  formataCelularDDD(celular): string{
    return Utilitarios.formataCelularDDD(celular);
  }

  getAccessToken(){
    this.preCheckoutService.Authentication()
    .subscribe(
      (result) => {
        new Auth(
                result.user_id, 
                result.authenticated, 
                result.access_token, 
                result.created, 
                result.expiration
        )
      },
      (err) => {
        this.internalError("Ocorreu um erro ao tentar recuperar token de acesso, tente novamente!");
      }
    );
  }

  internalError(err){
    this.alertService.alertDanger(err || this.translation.internalError, null);
  }

  atualizaCpfChecklist() {
    this.cpf$.subscribe(event => this.cpfSessao = event);
  }
}